var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Logoff White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Logoff-White",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0833333,6.25 L22.9166667,6.25 L22.9166667,27.0833333 L27.0833333,27.0833333 L27.0833333,6.25 Z M37.1458333,10.7708333 L34.1875,13.7291667 C37.4791667,16.375 39.5833333,20.4375 39.5833333,25 C39.5833333,33.0625 33.0625,39.5833333 25,39.5833333 C16.9375,39.5833333 10.4166667,33.0625 10.4166667,25 C10.4166667,20.4375 12.5208333,16.375 15.7916667,13.7083333 L12.8541667,10.7708333 C8.8125,14.2083333 6.25,19.2916667 6.25,25 C6.25,35.3541667 14.6458333,43.75 25,43.75 C35.3541667,43.75 43.75,35.3541667 43.75,25 C43.75,19.2916667 41.1875,14.2083333 37.1458333,10.7708333 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutWhite);
export default __webpack_public_path__ + "static/media/sign-out-white.8cd489f89f318ec35d499be91f405939.svg";
export { ForwardRef as ReactComponent };